<template>
    <footer id="mainfooter">
        <div class="copyright">
            2018 &copy; - Montelvini s.r.l. All rights reserved.
        </div>
        <router-link tag="a" :to="{ name: $i18n.locale+'.contact', query: { newsletter: true } }" class="newsletter" v-t="'menu.newsletter'"></router-link>
        <div class="credits">
            Website developed by <a href="https://www.coolmind.it">Cool Mind</a>
            <div v-if="$i18n.locale === 'it'" class="policies">
                <a href="https://www.iubenda.com/privacy-policy/28037983" class="iubenda-black no-brand iubenda-embed " title="Privacy Policy">Privacy Policy</a>
                <a href="https://www.iubenda.com/privacy-policy/28037983/cookie-policy" class="iubenda-black no-brand iubenda-embed " title="Cookie Policy">Cookie Policy</a>
            </div>
            <div v-if="$i18n.locale !== 'it'" class="policies">
                <a href="https://www.iubenda.com/privacy-policy/44187315" class="iubenda-black no-brand iubenda-embed " title="Privacy Policy">Privacy Policy</a>
                <a href="https://www.iubenda.com/privacy-policy/44187315/cookie-policy" class="iubenda-black no-brand iubenda-embed " title="Cookie Policy">Cookie Policy</a>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {

    }
</script>